module.exports = __webpack_public_path__ + "img/zhishizhongxin.b44851f6.png";